import en from './en.json';
import fr from './fr.json';

export enum Language {
    English,
    French
}

export const dictionaryList = { 
    [Language.English]: en, 
    [Language.French]: fr 
};

export type LanguageId = keyof typeof en;